import React, { useEffect, useRef } from "react";
import { useTrainingStore } from "../../stores/trainingStore";
import styled from "styled-components";
declare global {
  interface Window {
    kakao: any;
  }
}
const MapWrapper = styled.div`
  width: 100%;
  height: 280px;
  border-radius: 20px;
  overflow: hidden;
  margin: 20px 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.5);
`;
export const RunningMap: React.FC = () => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<any>(null);
  const polylineRef = useRef<any>(null);
  const markerRef = useRef<any>(null);

  const { positions, isActive } = useTrainingStore();

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    const script = document.createElement("script");
    const kakaoKey = process.env.REACT_APP_KAKAO_MAP_KEY;
    script.src = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${kakaoKey}&autoload=false`;
    script.async = true;

    script.onload = () => {
      window.kakao.maps.load(() => {
        const options = {
          center: new window.kakao.maps.LatLng(37.5665, 126.978),
          level: 3,
        };

        mapInstanceRef.current = new window.kakao.maps.Map(
          mapRef.current,
          options,
        );

        // 현재 위치로 이동
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((pos) => {
            const center = new window.kakao.maps.LatLng(
              pos.coords.latitude,
              pos.coords.longitude,
            );
            mapInstanceRef.current.setCenter(center);
          });
        }

        // 폴리라인 초기화
        polylineRef.current = new window.kakao.maps.Polyline({
          map: mapInstanceRef.current,
          path: [],
          strokeWeight: 5,
          strokeColor: "#FF6B6B",
          strokeOpacity: 0.8,
          strokeStyle: "solid",
        });

        // 현재 위치 마커
        markerRef.current = new window.kakao.maps.Marker({
          map: mapInstanceRef.current,
        });
      });
    };

    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    if (
      !mapInstanceRef.current ||
      !polylineRef.current ||
      positions.length === 0
    )
      return;

    const path = positions.map(
      (pos) => new window.kakao.maps.LatLng(pos.lat, pos.lng),
    );

    polylineRef.current.setPath(path);

    const lastPos = positions[positions.length - 1];
    const lastLatLng = new window.kakao.maps.LatLng(lastPos.lat, lastPos.lng);

    markerRef.current.setPosition(lastLatLng);

    if (isActive) {
      mapInstanceRef.current.setCenter(lastLatLng);
    }
  }, [positions, isActive]);

  return <MapWrapper ref={mapRef} className="running-map" />;
};
